module.exports = __webpack_public_path__ + "img/dota2.8477725a.jpg";